/* src/app/shared/layout/ag-tree/ag-tree.component.scss */
:host {
  display: block;
  border-bottom: 1px solid #c8c7cc;
  margin: 24px 0;
}
/*# sourceMappingURL=ag-tree.component.css.map */
